// © Microsoft Corporation. All rights reserved.

/**
 * The param-name prefix used when serializing params onto the query string.
 */
export const SSRRequestDataPrefix = "rd";

/**
 * Defines the "interop" contract between client and server-side renderer.
 * All of these values will be serialized into request parameters to be passed
 * on the HTTP request to the SSR server.
 */
export const SSRContract = {
    ver: "0.1.0",
    spec: {
        // IWindow
        innerWidth: {
            clientValue: () => window.innerWidth
        },
        innerHeight: {
            clientValue: () => window.innerHeight
        },
        locationHash: {
            clientValue: () => window.location.hash
        },
        locationHref: {
            clientValue: () => window.location.href
        },
        locationHost: {
            clientValue: () => window.location.host
        },
        locationHostName: {
            clientValue: () => window.location.hostname
        },
        locationOrigin: {
            clientValue: () => window.location.origin
        },
        locationPathName: {
            clientValue: () => window.location.pathname
        },
        locationProtocol: {
            clientValue: () => window.location.protocol
        },
        locationSearch: {
            clientValue: () => window.location.search
        },
        // IBrowser
        canUseCssGrid: {
            clientValue: () => ((window.CSS && window.CSS.supports && CSS.supports("display", "grid")) || false)
        },
        // IDevice
        devicePixelRatio: {
            clientValue: () => window.devicePixelRatio
        },
        // ILocale
        language: {
            clientValue: () => document.documentElement.lang
        },
        direction: {
            clientValue: () => document.documentElement.dir
        }
    }
};
